<template>
  <div class="user-agreement" data-automation="userAgreement">
    <div class="agreement-cont">
      <div class="agreement-header agreement-blod">{{ $t('HT.userAgreement.text1') }}</div>
      <div class="agreement-section">
        <p>
          {{ $t('HT.userAgreement.text2') }}
        </p>
        <p>{{ $t('HT.userAgreement.text3') }}</p>
        <p>{{ $t('HT.userAgreement.text4') }}</p>
        <p>{{ $t('HT.userAgreement.text5') }}</p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text6') }}</p>
        <p>
          {{ $t('HT.userAgreement.text7') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text8') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text9') }}</p>
        <p>
          {{ $t('HT.userAgreement.text10') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text11') }}</p>
        <p>
          {{ $t('HT.userAgreement.text12') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text13') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text14') }}</p>
        <p>
          {{ $t('HT.userAgreement.text15') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text16') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text17') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text18') }}</p>
        <p>
          {{ $t('HT.userAgreement.text19') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text20') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text21') }}
        </p>
        <p>
          {{ $t('HT.userAgreement.text22') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text23') }}</p>
        <p>{{ $t('HT.userAgreement.text24') }}</p>
        <p>
          {{ $t('HT.userAgreement.text25') }}
        </p>
        <p></p>
        <p></p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text26') }}</p>
        <p>
          {{ $t('HT.userAgreement.text27') }}
        </p>
      </div>

      <div class="agreement-section">
        <p class="agreement-blod">{{ $t('HT.userAgreement.text28') }}</p>
        <p>{{ $t('HT.userAgreement.text29') }}</p>
        <p class="agreement-red">{{ $t('HT.userAgreement.text30') }}</p>
        <p>{{ $t('HT.userAgreement.text31') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {}
};
</script>

<style lang="scss" scoped>
.user-agreement {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: $color-bg-disable;

  .agreement-cont {
    width: 1200px;
    margin: 0 auto;
    color: $color-text;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .agreement-header {
    padding: 64px 0 32px;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }

  .agreement-section {
    margin-bottom: 16px;
  }

  .agreement-blod {
    font-weight: 600;
    color: $color-title;
  }

  .agreement-red {
    color: $color-error;
  }
}
</style>
